import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';

const ActionRow = ({ onClear, onSave, isDisabled, isSaved, isErrorOccurred }) => (
    <div className="hp-notes__actionRow">
        <div className="hp-notes__actionRowButtons">
            <button
                onClick={onClear}
                disabled={isErrorOccurred}
                className="hp-notes__button ui-btn ui-btn_secondary ui-btn_hollow"
            >
                Clear
            </button>
            <button
                onClick={onSave}
                disabled={isDisabled}
                className={
                    classNames(
                        'hp-notes__button ui-btn ui-btn_primary ui-btn_major',
                        isDisabled && 'ui-btn_disabled'
                    )
                }
            >
                {isSaved ? (
                    <span>
                        <Svg iconName="tick" size="sizeNotesTick" />
                        <span className="hp-notes__buttonLabel">Saved</span>
                    </span>
                ) : 'Save'}
            </button>
        </div>
    </div>
);

ActionRow.propTypes = PropTypes.shape({
    onClear: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isSaved: PropTypes.bool.isRequired,
    isErrorOccurred: PropTypes.bool.isRequired,
}).isRequired;

export default ActionRow;



// WEBPACK FOOTER //
// ./src/js/horse/notes/components/ActionRow.jsx